export default __webpack_public_path__ + "static/media/illustration-health-1-m.fe4fd96c.webp";